import axios from 'axios'
import { store } from '../store'
import sidebar from '../utils/sidebar'
import { router } from './index';

export default async (from, to, next) => {
  try{
    let userRole = await axios.get('/api/auth/me/role', {
      headers: { 'Authorization': `Bearer ${store.getters.GET_TOKEN}` }
    })

    if(userRole.data.user_role === 2){
      store.dispatch('SET_SIDEBAR', sidebar.student)
      next()
    } else {
      router.go(-1)
    }
  } catch (e){
    store.dispatch('LOGGED_OUT')
    next('/')
  }
}


// WEBPACK FOOTER //
// ./src/router/studentguard.js